



































import Vue from 'vue';
import { convertDateToAmericanFormat } from '../lib/utils';

export default Vue.extend({
    props: {
        value: {
            required: false,
            type: String,
        },
        label: {
            required: false,
            type: String,
        },
        width: {
            required: false,
            type: String,
        },
        disabled: {
            required: false,
            type: Boolean,
            default: false,
        },
        'allowed-dates': {
            required: false,
            default: null,
        },
        loading: {
            required: false,
            type: Boolean,
            default: false,
        },
        rules: {
            required: false,
            default: () => [],
        },
    },
    data() {
        return {
            dateMenu: false,
            menuX: 0,
            menuY: 0,
        };
    },
    computed: {
        dateRangeText(): string | undefined {
            if (!this.value) {
                return undefined;
            }
            return `${convertDateToAmericanFormat(this.value as string)}`;
        },
    },
    methods: {
        showDatesMenu(e: any) {
            e.preventDefault();
            this.dateMenu = false;
            this.menuX = e.clientX;
            this.menuY = e.clientY;
            this.$nextTick(() => {
                this.dateMenu = true;
            });
        },
    },
});
